module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Dramatis Personae")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Jean-Claude (Rod) Simone")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Julie Phillips Simone—Rod’s wife")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Nanette Marie Simone—Rod’s daughter")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Major General Hank McCluney, US Army Air Corps—Rod’s (deceased) adoptive father")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Mary McCluney—Rod’s adoptive mother")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_SubChapHead"
  }, [_c('span', [_vm._v("Washington DC")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Ambassador T. Edward Phillips—Rod’s father-in-law")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Francine Phillips—Rod’s mother-in-law")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_SubChapHead"
  }, [_c('span', [_vm._v("Colorado Springs")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("George Delante—Land developer and co-owner, High Country Construction")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Elizabeth Delante—his wife")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Fred Delante—his son")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Jim-Tom Henderson—Co-owner, High Country Construction")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Darius Moore—ex-El Paso County DA; Legal Counsel, Colorado Technical Associates")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_SubChapHead"
  }, [_c('span', [_vm._v("United States Air Force Academy")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Captain Bobby Andrew—Executive Officer, Department of Theoretical Mechanics")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Brigadier General Stanley C. Beck"), _c('span', {
    staticStyle: {
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_vm._v("†")]), _vm._v("—USAFA Commandant")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Raf Garcia—waiter")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Mrs. Gail McComas"), _c('span', {
    staticStyle: {
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_vm._v("†")]), _vm._v("—Cadet hostess, 1955 to 1977")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Ben Martin"), _c('span', {
    staticStyle: {
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_vm._v("†")]), _vm._v("—USAFA football coach")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Colonel Maas—Department Head and Permanent Professor, Department of Law")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Brigadier General Robert F. McDermott"), _c('span', {
    staticStyle: {
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_vm._v("†")]), _vm._v("—USAFA Dean of Faculty")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Brigadier General Robert W. Strong, Jr."), _c('span', {
    staticStyle: {
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_vm._v("†")]), _vm._v("—USAFA Commandant")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Colonel L. Bradford Whitney—Department Head and Permanent Professor, Department of Theoretical Mechanics")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_SubChapHead"
  }, [_c('span', [_vm._v("Rod Simone’s USAFA classmates")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Nino Baldacci"), _c('span', {
    staticStyle: {
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_vm._v("†")]), _vm._v("—Cadet (Poughkeepsie, NY)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Sylvester “Sly” Winston Jakes—(Boston, MA)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Jeff Goldstein—(New York, NY)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Manuel Rojo—(Albuquerque, NM)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("George Sanders—(Fort Worth, Texas)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_SubChapHead"
  }, [_c('span', [_vm._v("Other Locations")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Captain Charlie “Rhino” Banner—Instructor pilot")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("“Beast”—Squadron Commander, 3525th Pilot Training Wing, Williams AFB")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("General “Speedy” Beaumont—Major General Hank McCluney’s WWII wingman")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Captain “Jazz” Ferguson—Rod’s F-4 GIB (Guy-In-the-Backseat)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Major Tom Ranch—F-105 pilot, Rod Simone’s ex-ATO and ex-AOC")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Professor Clifford Rhoades—Professor of Aeronautical Engineering, Stanford University")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_LineItem"
  }, [_vm._v("Barbara Richardson—Stanford graduate student, newscaster")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyTextFirstPara"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_vm._v("†—")]), _c('i', [_vm._v("Denotes an actual historical figure")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34f5746a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0007.vue
// module id = 78
// module chunks = 0